import types from '../constants'
import { findIndexByKeyValue } from './util'

const initialState = {
  leagueList: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  matchesPlaylists: {
    meta: {
      status: 'loading',
    },
    data: [],
  },

  // NEW VERSION
  leagues: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  matches: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
  banners: {
    meta: {
      status: 'loading',
    },
    data: [],
  },
}

export default function matches(state = initialState, action) {
  switch (action.type) {
    case types.GET_MATCHES_PLAYLIST_LOADING:
      // console.log('matches reducers loading', action.payload)
      return { ...state, ...action.payload }
    case types.GET_MATCHES_PLAYLIST_SUCCESS:
      // console.log('matches reducers success', action.payload)
      return { ...state, ...action.payload }
    case types.GET_MATCHES_PLAYLIST_ERROR:
      return {
        ...state,
        ...action.payload,
      }

    case types.GET_MATCHES_GENRESPO_LOADING:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_GENRESPO_SUCCESS:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_GENRESPO_ERROR:
      return { ...state, ...action.payload }

    case types.UPDATE_ACTIVE_MATCHES_PLAYLIST:
      return { ...state, ...action.payload }

    case types.GET_MATCHES_BANNER_LOADING:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_BANNER_SUCCESS:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_BANNER_ERROR:
      return { ...state, ...action.payload }

    // NEW VERSION
    case types.GET_MATCHES_LEAGUE_REQUEST:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_LEAGUE_SUCCESS:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_LEAGUE_ERROR:
      return { ...state, ...action.payload }

    case types.GET_MATCHES_MATCHES_RESET:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_MATCHES_REQUEST:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_MATCHES_SUCCESS:
      return { ...state, ...action.payload }
    case types.GET_MATCHES_MATCHES_ERROR:
      return { ...state, ...action.payload }

    case types.MATCHES_VIDEO_REMINDERS:
      let currentMatches = { ...state.matches }
      currentMatches.data.map((pl) => {
        if (pl.id === action.payload.playlistId) {
          pl.reminders = action.payload.reminders
        }
      })

      return {
        ...state,
        matches: {
          ...currentMatches,
        }
      }

    case types.MATCHES_PLAYLISTS_VIDEO_REMINDERS:
      let currentLeaguesMatches = { ...state.matchesPlaylists }
      currentLeaguesMatches.data.map((pl) => {
        if (pl.id === action.payload.playlistId) {
          pl.reminders = action.payload.reminders
        }
      })

      return {
        ...state,
        matchesPlaylists: {
          ...currentLeaguesMatches,
        }
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}
